import React from "react";
import Search from "./Search/Search";

const SearchPage = () => {
  return <Search />;
};

export default SearchPage;
